var map = {
	"./arrow-tip-down.svg": "f41a",
	"./arrow-tip-up.svg": "acc9",
	"./charges.svg": "2fa5",
	"./financial-area.svg": "ebaf",
	"./transfer_funds.svg": "4df1",
	"./waiting_time.svg": "23df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37f8";